import React from "react";
import { Container } from "react-bootstrap";

export const MainOpportunities = () => {
  return (
    <Container fluid className="banner_main1">
      <div>
        <div>
          <div>
            <div>
              <Container>
                <div>
                  <div className="bg_white text-white text-center">
                    <h1 className="text-6xl robot">Find Opportunities</h1>
                    <div>
                      <p className="text-lg p-2">
                        Opportunities are waiting for you
                      </p>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
